module.exports = __webpack_public_path__ + "static/img/001.32e844a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/001.png
// module id = Ix82
// module chunks = 1